var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardVideoMsg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2047_15308",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2047_15308",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAWJJREFUaEPtmM1NAzEQhb+0AwVwhVNoILRBCUADFJJUwI1jaIB2QCPtSs5irz3xTzRhfImitT3vzfM8/2ww3jbG8eMELq2gK+AKVGbgapfQDfAObCsTVDr8C3gG5FfVYgrcAUfVLO063wLfmuliBAS8kLhE+wAeNYFjBH6CCUbVyNkxnYBG7pW+/0aBPfAUJqLlErpfZPhToU6JAgJ+B6cH0JYEXoGXCfQbIP9LW47ADF7mO8FsgUAI3hyBJXhTBGLgzRBIgTdB4DC5TcoAqot4zV1CF0oBEHtdWmzoQjnnqiagCRYD8+AEMqfN3KZifgml1mirnbh7EfcmIEVq2kZnlzG9kc0qmz5KpEhU7wMjamAZY8hxOreDrn3PWbeM7X6h6U1gJtHtSjmCwJ8YLW9kTmDKgOox7SqfFs0/7oqSpp/Xa4px+FhVwQxHVxDQCRQkqWsXV6BregsmdwUKktS1yy+nmHUxIJIsAwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardVideoMsg);
export default __webpack_public_path__ + "static/media/DashboardVideoMsg.2b8cd35cb5501c820f368e0a8a9e014e.svg";
export { ForwardRef as ReactComponent };